import React from 'react'
import { getPeriodString } from './PeriodInput'
import moment from 'moment'
import { Table } from 'react-bootstrap'

const formatValue = (type, value) => {
  if (!value && !'boolean' === type) {
    return ''
  }
  switch (type) {
    case 'period':
      return getPeriodString(value)
    case 'date':
      return moment(value).format('DD-MM-YYYY')
    case 'duration':
      if (value[0]) {
        return getPeriodString(value[0])
      } else {
        return formatValue('date', value[1]) + ' / ' + formatValue('date', value[2])
      }
    case 'start-end':
      return formatValue('date', value[0]) + ' / ' + formatValue('date', value[1])
    case 'ip-range':
      return value[0] + ' - ' + value[1]
    case 'boolean':
      return value ? 'Ja' : 'Nee'
    case 'deleted-location':
      return value[0] + ': ' + value[1] + ' - ' + value[2]
    case 'choice':
      return isString(value) ? value : value && value.name ? value.name : ''
    default:
      return value
  }
}

const isString = (value) => {
  return typeof value === 'string'
}

const RevisionTable = ({ revisions, type }) => (
  <Table striped condensed style={{ width: 600 }}>
    <thead>
      <tr>
        <th style={{ width: 150 }}>Datum</th>
        <th style={{ width: 200 }}>Wie</th>
        <th>Waarde</th>
      </tr>
    </thead>
    {revisions ? (
      <tbody>
        {revisions.map((r, i) => (
          <tr key={i}>
            <td>{moment(r.timestamp).format('DD-MM-YYYY HH:mm')}</td>
            <td>{r.user}</td>
            <td>{formatValue(type, r.value)}</td>
          </tr>
        ))}
      </tbody>
    ) : (
      <tbody />
    )}
  </Table>
)

export default RevisionTable
